import { BookOpenCheckIcon, FileTextIcon, FolderOpenIcon, LightbulbIcon, ListChecksIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  items?: string[];
  benefit: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Oil & Gas Classroom Activities & Challenges',
    description:
      '150 ready-to-use activity ideas covering Oil & Gas fundamentals, petroleum geology, exploration, drilling, production, refining, natural gas processing, LNG, pipelines, transportation, safety, environmental management, economics, and energy transition. Organized by difficulty level and topic.',
    benefit: 'Materials already designed for your classroom: saves hours every quarter.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'Oil & Gas Assessment Bank',
    description:
      'Comprehensive assessment resources designed to evaluate student learning throughout an Oil & Gas course. Includes:',
    items: [
      'Foundational assessments',
      'Intermediate assessments',
      'Advanced assessments',
      'Short-answer questions',
      'Definition and explanation questions',
      'Compare-and-contrast exercises',
      'Cause-and-effect questions',
      'Concept application',
      'Misconception correction',
      'Scenario analysis',
      'Evidence interpretation',
      'Critical-thinking questions',
      'Extended responses',
      'Integrated assessments',
      'Teacher answer guidance',
    ],
    benefit: 'Never build an exam from scratch under pressure again.',
    value: 'USD 14',
    icon: ListChecksIcon,
  },
  {
    number: '03',
    title: '100 Oil & Gas Case Studies & Industry Scenarios',
    description:
      'A collection of 100 developed Oil & Gas cases involving industry fundamentals, geology and reservoirs, exploration uncertainty, drilling and wells, production systems, refining, natural gas processing, LNG and transportation, pipelines and infrastructure, safety and risk, environmental challenges, economics, global markets, energy security, and energy transition.',
    benefit:
      'Students analyze evidence, answer guiding questions, evaluate situations, justify ideas, and think critically.',
    value: 'USD 14',
    icon: FileTextIcon,
  },
  {
    number: '04',
    title: '50 Oil & Gas Classroom Projects & Inquiry Challenges',
    description:
      '50 structured classroom projects that encourage students to investigate Oil & Gas topics, analyze problems, develop understanding, make recommendations, and communicate their learning through practical classroom work. Each includes objectives, background information, student challenges, instructions, guiding questions, and assessment criteria.',
    benefit: 'Your students finish the year with real Oil & Gas learning projects.',
    value: 'USD 14',
    icon: LightbulbIcon,
  },
  {
    number: '05',
    title: "Oil & Gas Teacher's Dictionary: 200 Essential Concepts Explained",
    description:
      'Comprehensive reference handbook covering 200 essential Oil & Gas concepts designed to help teachers explain vocabulary and concepts clearly. Includes terminology related to:',
    items: [
      'Industry fundamentals',
      'Petroleum geology',
      'Reservoirs',
      'Exploration',
      'Drilling',
      'Well construction',
      'Production',
      'Refining',
      'Natural gas processing',
      'Petroleum products',
      'Midstream',
      'LNG',
      'Transportation',
      'Safety and risk',
      'Environmental management',
      'Economics',
      'Global markets',
      'Energy security',
      'Energy transition',
    ],
    benefit: 'Project it in class and your students instantly understand complex Oil & Gas concepts.',
    value: 'USD 14',
    icon: BookOpenCheckIcon,
    wide: true,
  },
];
